export const isUserSessionActive = (expDate) => {
  const expiresAt = new Date(expDate * 1000);
  const now = Date.now();

  return expiresAt > now;
};
